<template>
  <div class="uploadImg">
    <input
        class="inputfiles"
        type="file"
        ref="inputfile"
        @change="upload"
        id="addimgfiles"
        accept="image/jpg,image/jpeg,image/png"
    />
    <!-- hidden -->
  </div>
</template>

<script>
import { uploadFile } from "@/server/api.js";
export default {
  name: "imgFile",
  props: {
    size: {
      type: Number,
      default: 10,
    },
  },
  data(){
    return {

    }
  },
  methods:{
    trimSpecial(string){
      if (string != "") {
        const pattern = /[`~!@#$^\-&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;
        pattern.lastIndex = 0;
        // console.log(string.match(pattern))
        return pattern.test(string);
      }
    },
    upload(e){
      let file = e.target.files[0];
      const fileType = [".jpg", ".jpeg", ".png", ".JPG", ".JPEG", ".PNG"];
      let size = parseFloat((file.size / 1024 / 1024).toFixed(2));
      const suffix = file.name.substring(
          file.name.lastIndexOf("."),
          file.name.length
      );

      if (size > this.size) {
        return this.$notify({type:"warning",message:"大小不允许超过" + this.size + "MB"});
      }
      if (fileType.indexOf(suffix) === -1) {
        return this.$notify({type:"warning",message:"请上传正确格式的文件"});
      }
      let formdata = new FormData();
      formdata.append("filrName", file);
      uploadFile(formdata).then((res) => {
        this.$emit("uploadImg", {
          fileName:res.data.fileName,
          size:file.size,
          url:res.data.url
        },this.size);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.uploadImg {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
}
.updataimgs {
  width: 100%;
  height: 100%;
  background-color: #fafafa;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  .icons {
    font-size: 24px;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .iconTop {
    top: -12px;
  }
  .center-text {
    font-size: 12px;
    color: #999999;
    position: absolute;
    bottom: 14px;
  }

  .inputimgs {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .clear-icon {
    position: absolute;
    z-index: 5;
    top: -12px;
    right: -12px;
    font-size: 23px;
    color: #e4393c;
    background: #fff;
    border-radius: 1000%;
    cursor: pointer;
  }
}
.inputfilesp {
  height: 0;
  width: 0;
  overflow: hidden;
}
.inputfiles {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 99;
}
</style>
